import { Pipe, PipeTransform } from '@angular/core';
import { get } from 'lodash';

/*
 * Format string
 * Usage:
 *   Array<unknow> | join
 *   Array<unknow> | join:joinArg:separator
 * Example:
 *   {{ values | join:'property' }}
 *   formats to: value1, value2
 */
@Pipe({
    name: 'join',
    standalone: false
})
export class JoinPipe implements PipeTransform {
  transform(values: Array<unknown>, joinArg = '', separator = ', '): string {
    if (joinArg) {
      return values
        .map((value) => String(get(value, joinArg, '')))
        .filter(Boolean)
        .join(separator);
    }
    return values.join(separator);
  }
}
